import './about.css';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faDatabase,
  faCogs,
  faBalanceScale,
  faShareAlt,
  faClock,
  faUserCheck,
  faLock,
  faCookie,
  faEdit,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";


const Politica = () => {
  return (
   
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
           


                     <div className='tittle-ab-top'>
                        <h4>Confidentialitatea datelor</h4>
                    </div>
           
                   
           
              {/* Informatii generale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Informatii generale</h4>
    <p>
      Aceasta politica descrie modul in care colectam, utilizam, stocam si protejam datele tale cu caracter personal atunci cand folosesti platforma ContaLearn (www.contalearn.ro).
    </p>
  </div>
</section>

{/* Ce date colectam */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Ce date colectam</h4>
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>Date de identificare: nume, adresa de e-mail, parola, data nasterii</li>
      <li>Date privind utilizarea: cursuri accesate, progres, raspunsuri la teste si exercitii</li>
      <li>Date tehnice: adresa IP, tip browser, sistem de operare, dispozitiv utilizat</li>
      <li>Alte informatii oferite voluntar prin formulare, chestionare sau campuri de feedback</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faDatabase} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Cum folosim aceste date */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCogs} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Cum folosim aceste date</h4>
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>Crearea si administrarea contului tau</li>
      <li>Accesul la lectii, teste, jocuri si certificari</li>
      <li>Personalizarea experientei de invatare</li>
      <li>Analiza si imbunatatirea platformei si continutului</li>
      <li>Comunicari legate de noutati, actualizari sau promotii (numai cu acordul tau)</li>
    </ul>
  </div>
</section>

{/* Temeiul legal al prelucrarii */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Temeiul legal al prelucrarii</h4>
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>Executarea unui contract (ex. crearea si gestionarea contului)</li>
      <li>Consimtamantul tau expres (ex. abonarea la newsletter)</li>
      <li>Interes legitim (ex. analiza comportamentului utilizatorilor)</li>
      <li>Obligatii legale (ex. securitate IT, arhivare contabila)</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Cui transmitem datele */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShareAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Cui transmitem datele</h4>
    <p>
      Nu vindem si nu inchiriem datele tale personale. Datele pot fi transmise catre terti de incredere (ex. procesatori de plati, servicii de e-mail, instrumente de analiza) care actioneaza in numele nostru si respecta standarde stricte de confidentialitate.
    </p>
  </div>
</section>

{/* Cat timp pastram datele */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Cat timp pastram datele</h4>
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>Pe durata existentei contului tau activ</li>
      <li>Sau atat timp cat este necesar pentru scopurile mentionate mai sus</li>
    </ul>
    <p>Poti solicita oricand stergerea contului si a datelor asociate.</p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faClock} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Drepturile tale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faUserCheck} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Drepturile tale</h4>
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      <li>Dreptul de acces la date</li>
      <li>Dreptul de corectare sau stergere</li>
      <li>Dreptul de a restrictiona prelucrarea</li>
      <li>Dreptul la portabilitate</li>
      <li>Dreptul de opozitie</li>
      <li>Dreptul de a depune plangere la <a href='https://www.dataprotection.ro/' target='_blank' rel='noopener noreferrer'>ANSPDCP</a></li>
    </ul>
    <p>Pentru exercitarea drepturilor, scrie-ne la: <strong>contact@contalearn.ro</strong></p>
  </div>
</section>

{/* Securitatea datelor */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Securitatea datelor</h4>
    <p>
      Aplicam masuri tehnice si organizatorice adecvate pentru a proteja datele personale impotriva accesului neautorizat, pierderii, modificarii sau divulgarii neautorizate.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faLock} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Cookie-uri */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faCookie} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Cookie-uri</h4>
    <p>
      Folosim cookie-uri pentru buna functionare a site-ului, analiza traficului si imbunatatirea experientei de utilizare.
      Detalii complete se gasesc in <Link to='/politicacookies'>Politica de Cookie-uri</Link>.
    </p>
  </div>
</section>

{/* Modificari ale politicii */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Modificari ale politicii</h4>
    <p>
      Aceasta politica poate fi actualizata periodic. Versiunile modificate vor fi publicate pe aceasta pagina.
      In cazul modificarilor semnificative, vei fi notificat prin e-mail sau direct in platforma.
    </p>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEdit} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Contact */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEnvelope} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Contact</h4>
    <p>
      Pentru orice intrebare legata de confidentialitatea datelor tale, te rugam sa ne contactezi la:<br />
      📩 <strong>contact@contalearn.ro</strong>
    </p>
  </div>
</section>

           
            <div className='line-about'></div>
           
                 
           
                 </div>
               </div>
   
  );
};

export default Politica;
